import { Injectable, inject } from '@angular/core'
import { type Observable } from 'rxjs'

import { GraphService } from 'src/app/shared/lib/api/graph.service'

import { type BankTransactionInput } from '../model/bank-transaction.model'

@Injectable({ providedIn: 'root' })
export class BankTransactionApi {
  private readonly graphQL = inject(GraphService)

  createMany (transactions: BankTransactionInput[]): Observable<{ addTransaccionesBanco: boolean }> {
    return this.graphQL.mutateGraphQL<{ addTransaccionesBanco: boolean }>({
      mutation: `mutation addTransaccionesBanco($transacciones:[inputTransaccionBanco!]!){
        addTransaccionesBanco(transacciones:$transacciones)
      }`,
      variables: { transacciones: transactions }
    })
  }

  getExistingIds (ids: string[]): Observable<{ getExistingTransactionIds: string[] }> {
    return this.graphQL.queryGraphQL<{ getExistingTransactionIds: string[] }>({
      query: `query getExistingTransactionIds($ids: [String!]!) {
        getExistingTransactionIds(ids: $ids)
      }`,
      variables: { ids }
    })
  }
}
